'use strict';

var processInclude = require('base/util');

processInclude(require('./countrySelector'));
processInclude(require('./textShowMore'));
processInclude(require('./productTile'));
processInclude(require('./search'));
